module.exports = __webpack_public_path__ + "img/activity_fun3.c7f54cb1.jpg";